import listActions from '../../../modules/teacher/list/teacherListActions'
import TeacherService from '../../../modules/teacher/teacherService'
import Errors from '../../../modules/shared/error/errors'
import { i18n } from '../../../i18n'
import { push } from 'redux-first-history'
import Message from '../../../view/shared/message'

const prefix = 'TEACHER_DESTROY'

const teacherDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: teacherDestroyActions.DESTROY_STARTED,
      })

      await TeacherService.destroyAll([id])

      dispatch({
        type: teacherDestroyActions.DESTROY_SUCCESS,
      })

      Message.success(
        i18n('entities.teacher.destroy.success'),
      )

      dispatch(listActions.doFetchCurrentFilter())

      dispatch(push('/teacher'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: teacherDestroyActions.DESTROY_ERROR,
      })
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: teacherDestroyActions.DESTROY_ALL_STARTED,
      })

      await TeacherService.destroyAll(ids)

      dispatch({
        type: teacherDestroyActions.DESTROY_ALL_SUCCESS,
      })

      if (listActions) {
        dispatch(listActions.doClearAllSelected())
        dispatch(listActions.doFetchCurrentFilter())
      }

      Message.success(
        i18n('entities.teacher.destroyAll.success'),
      )

      dispatch(push('/teacher'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: teacherDestroyActions.DESTROY_ALL_ERROR,
      })
    }
  },
}

export default teacherDestroyActions
